import { render, staticRenderFns } from "./EipPagination.vue?vue&type=template&id=4c0e6576&scoped=true&"
import script from "./EipPagination.vue?vue&type=script&lang=js&"
export * from "./EipPagination.vue?vue&type=script&lang=js&"
import style0 from "./EipPagination.vue?vue&type=style&index=0&id=4c0e6576&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e6576",
  null
  
)

export default component.exports